import { Box, Typography } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  withoutPaper?: boolean;
  paddingY?: number;
  message?: string;
};

export const CommonError = ({ withoutPaper, paddingY = 3, message }: Props) => {
  const { t } = useResource();

  const messageContent = (
    <Typography color="red">
      {message || t(Resources.Error.SomethingWentWrong)}
    </Typography>
  );

  if (withoutPaper) {
    return <Box paddingY={paddingY}>{messageContent}</Box>;
  }

  return <PrimaryPaper>{messageContent}</PrimaryPaper>;
};
